// extracted by mini-css-extract-plugin
export var fadeIn = "layout-module--fadeIn--3dee0";
export var grid = "layout-module--grid--ca99f";
export var gridWithRowGap = "layout-module--grid--with-row-gap--d5233";
export var layout = "layout-module--layout--d1074";
export var layout__mainContent = "layout-module--layout__main-content--cda07";
export var layout__skipToContent = "layout-module--layout__skip-to-content--60b0c";
export var maxWidthContainer = "layout-module--max-width-container--29a88";
export var mt0 = "layout-module--mt-0--6ea7a";
export var mt1 = "layout-module--mt-1--a19b7";
export var mt2 = "layout-module--mt-2--fe0ea";
export var mt3 = "layout-module--mt-3--994a1";
export var mt4 = "layout-module--mt-4--e6ad5";
export var mt5 = "layout-module--mt-5--a8f4d";
export var mt6 = "layout-module--mt-6--d79ef";
export var removeVisuallyHidden = "layout-module--remove-visually-hidden--94e85";
export var visuallyHidden = "layout-module--visually-hidden--678b9";
export var widgetBase = "layout-module--widget-base--1a2f5";